export const furniture = [

    {
        id: 1,
        name: 'Celestial Microfibre/Microsuede',
        price: '$250',
        imageUrl: 'https://i.ibb.co/QFYRZ2R/koig-global-2-CESLDPAni-Oc.jpg'
    },
    {
        id: 2,
        name: 'palmer Velvet 72 by Wrough Studio',
        price: '$120',
        imageUrl: 'https://i.ibb.co/8MGPrf7/koig-global-1-CESLDPAni-Oc.jpg'
    },
    {
        id: 3,
        name: 'Twin 66.1" Tuffed Back Convertible Sofa by serta futons',
        price: '$100',
        imageUrl: 'https://i.ibb.co/74SHV1R/koig-interiors-4-CCLam-VBhrd-W.jpg'
    },
    {
        id: 4,
        name: 'ibiza Microfibre 80.3" Flared Arm sofa by Zipcode Design',
        price: '$299.99',
        imageUrl: 'https://i.ibb.co/RHMyy1n/koig-interiors-1-CCLagdihtj-M.jpg'
    },
    {
        id: 5,
        name: 'Adkins Velvet 67" by Rosdof Park',
        price: '$250',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/21431055/resize-h310-w310%5Ecompr-r85/8911/89119820/Hubbardston+84%2522+Square+Arm+Sofa.jpg'
    },
    {
        id: 6,
        name: 'Elosie Swivel Armchair',
        price: '$400',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/00745373/resize-h310-w310%5Ecompr-r85/7956/79563518/Evan+Microfiber/Microsuede+66.5%2522+Square+Arm+Sleeper.jpg'
    },
    {
        id: 7,
        name: 'Edgar reclining arm sofa by andover millls',
        price: '$399',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/36504855/resize-h310-w310%5Ecompr-r85/1211/121142827/Fiedler+54%2522+Square+Arm+Loveseat.jpg'
    },
    {
        id: 8,
        name: 'collect Armchair',
        price: '$400',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/86589172/resize-h310-w310%5Ecompr-r85/3063/30633444/Mendoza+103.5%2522+Right+Hand+Facing+Sectional+with+Ottoman.jpg'
    },
    {
        id: 9,
        name: 'garren 75.6" square arm sofa by mercury raw',
        price: '$160',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/37392203/resize-h310-w310%5Ecompr-r85/6979/69798821/Maraca+Full+76.78%2522+Split+Back+Convertible+Sofa.jpg'
    },
    {
        id: 10,
        name: 'Lilo Barrel Chair',
        price: '$599',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/42031728/resize-h310-w310%5Ecompr-r85/9536/95366611/Syliva+Sleeper.jpg'
    },
    {
        id: 11,
        name: 'Celestial Microfibre flaced arm sofa by andover mills',
        price: '$600',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/84980788/resize-h310-w310%5Ecompr-r85/8348/83482383/Erinn+67%2522+Flared+Arms+Loveseat.jpg'
    },
    {
        id: 12,
        name: 'Harval square arm sofa by orren ellis',
        price: '$400',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/32605646/resize-h310-w310%5Ecompr-r85/6496/64960226/Vincent+24%2522+Armchair.jpg'
    },
    {
        id: 13,
        name: 'Hudbarston square arm sofa by three posts',
        price: '$190',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/26219602/resize-h310-w310%5Ecompr-r85/3742/37422283/Giuliana+104%2522+Reversible+Sectional+with+Ottoman.jpg'
    },
    {
        id: 14,
        name: 'Maraca Full 76.78" split Back',
        price: '$299',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/44138824/resize-h310-w310%5Ecompr-r85/1219/121994740/Dengler+79%2522+Square+Arm+Sofa+Bed.jpg'
    },
    {
        id: 15,
        name: 'Ibiza loveseat by Zipcode deesign',
        price: '$350',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/38450806/resize-h310-w310%5Ecompr-r85/9666/96668752/Cricklade+Velvet+72%2522+Round+Arms+Sleeper.jpg'
    },
    {
        id: 16,
        name: 'Edjar Reclining Arm sofa by Andover MIlls',
        price: '$300',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/43357495/resize-h310-w310%5Ecompr-r85/6128/61280951/Harlem+Genuine+Leather+Chesterfield+86%2522+Rolled+Arm+Sofa.jpg'
    },
    {
        id: 17,
        name: 'Akia 78" convertible by Hahtag Home',
        price: '$299',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/40866260/resize-h240-w240%5Ecompr-r85/6729/67294560/default_name.jpg'
    }


];